export const INSTALL_DISMISSED_KEY = 'classwise.pwa.installDismissed.v2';
const INSTALL_DISMISS_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export const isStandaloneDisplay = () => {
  if (typeof window === 'undefined') return false;

  const displayModeStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const displayModeFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
  const iosStandalone = window.navigator.standalone === true;

  return displayModeStandalone || displayModeFullscreen || iosStandalone;
};

export const isIosDevice = () => {
  if (typeof navigator === 'undefined') return false;

  const userAgent = navigator.userAgent || '';
  const classicIos = /iPad|iPhone|iPod/.test(userAgent);
  const ipadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  return classicIos || ipadOs;
};

export const wasInstallDismissed = () => {
  try {
    const raw = window.localStorage.getItem(INSTALL_DISMISSED_KEY);
    if (!raw) return false;

    // Legacy value from older builds
    if (raw === '1') return true;

    const dismissedAt = Number(raw);
    if (!Number.isFinite(dismissedAt)) return false;

    if (Date.now() - dismissedAt >= INSTALL_DISMISS_TTL_MS) {
      window.localStorage.removeItem(INSTALL_DISMISSED_KEY);
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

export const dismissInstallHint = () => {
  try {
    window.localStorage.setItem(INSTALL_DISMISSED_KEY, String(Date.now()));
  } catch {
    // Ignore quota / private-mode failures
  }
};

const DEV_SW_CLEARED_KEY = 'classwise.pwa.devSwCleared';

export const unregisterDevServiceWorkers = async () => {
  if (typeof window === 'undefined' || !import.meta.env.DEV) return;

  const hadController = Boolean(navigator.serviceWorker?.controller);

  if (navigator.serviceWorker) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }

  if (window.caches) {
    const cacheKeys = await caches.keys();
    await Promise.all(cacheKeys.map((key) => caches.delete(key)));
  }

  if (!hadController) return;

  try {
    if (window.sessionStorage.getItem(DEV_SW_CLEARED_KEY) === '1') return;
    window.sessionStorage.setItem(DEV_SW_CLEARED_KEY, '1');
  } catch {
    return;
  }

  window.location.reload();
};

export const hardReloadApp = async () => {
  if (typeof window === 'undefined') return;

  try {
    if (navigator.serviceWorker) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
  } catch {
    // Keep going so the page still reloads
  }

  try {
    if (window.caches) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }
  } catch {
    // Keep going so the page still reloads
  }

  try {
    await fetch(`${window.location.pathname}${window.location.search}`, {
      cache: 'reload',
      credentials: 'same-origin'
    });
  } catch {
    // Network failures should not block the reload
  }

  window.location.reload();
};
